// lib/clientFetchers/fetchDataAndMeta.js

/**
 * Fetch paginated data and meta for authors, categories, or category posts.
 * @param {Object} opts
 * @param {string} opts.type - "authors", "categories", "categoriesposts", or "posts"
 * @param {string} [opts.q] - Search query
 * @param {string} [opts.categorySlug] - Required for category posts
 * @param {number} [opts.page=1]
 * @param {number} [opts.limit=12]
 */
export const fetchDataAndMeta = async ({
    type, // "authors", "categories", etc
    q = "",
    page = 1,
    limit = 12,
    categorySlug,
}) => {
    const params = new URLSearchParams();
    if (q) params.set("q", q);
    params.set("page", page);
    params.set("limit", limit);

    let url;
    if (type === "authors") url = `/api/authors?${params}`;
    else if (type === "categories") url = `/api/categories?${params}`;
    else if (type === "categoryPosts" && categorySlug)
        url = `/api/categories/${encodeURIComponent(
            categorySlug
        )}/posts?${params}`;
    else throw new Error("Invalid fetch type");

    const res = await fetch(url);
    const result = await res.json();
    return { data: result.data, meta: result.meta };
};
